export default __webpack_public_path__ + "static/media/sv_10.7df984e5.webp";